import { useEffect, useState } from 'react'

export interface Countdown {
  hours: string
  minutes: string
  seconds: string
}

function msUntilEndOfDay(): number {
  const now = new Date()
  const end = new Date(now)
  end.setHours(23, 59, 59, 999)
  return end.getTime() - now.getTime()
}

function format(ms: number): Countdown {
  const total = Math.max(0, Math.floor(ms / 1000))
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const seconds = total % 60
  const pad = (value: number) => String(value).padStart(2, '0')
  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) }
}

export function useCountdown(): Countdown {
  const [remaining, setRemaining] = useState(() => format(msUntilEndOfDay()))

  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(format(msUntilEndOfDay()))
    }, 1000)
    return () => window.clearInterval(interval)
  }, [])

  return remaining
}
